import React from 'react';
import PropTypes from 'prop-types';

import BarEntity from 'components/BarEntity';
import Container from 'components/Container';

import styles from './styles.module.scss';

const EntityTopBar = ({
	breadcrumbs,
	entity,
	entityType,
	showEntityTitle = false
}) => (
	<div className={styles.EntityTopBar}>
		<Container width="entity" noPrint>
			<BarEntity {...{ breadcrumbs, entity, entityType, showEntityTitle }} />
		</Container>
	</div>
);

EntityTopBar.propTypes = {
	breadcrumbs: PropTypes.array,
	entity: PropTypes.object,
	entityType: PropTypes.string,
	showEntityTitle: PropTypes.bool
};

export default EntityTopBar;
